import CommentsEntityTypes from './commentsEntityTypes';

const getCommentEntityUrl = ({ spaceId, entityType, entityId }) => {
  return entityType === CommentsEntityTypes.post
    ? `dashboard/${spaceId}/community/post/${entityId}`
    : `dashboard/${spaceId}/journey/materials/${entityId}`;
};

export default getCommentEntityUrl;
